import type { VintedIntegration } from "src/interfaces/plaidIntegration.interface";
import type { SyncLock } from "../syncLock";
import {
  getExistingInventoryListingIds,
  listingIdsFromInventoryDownloadPayload,
  loadPendingInventoryListingIds,
  writeInventoryDownloadBatch,
} from "../inventoryDaily";
import { getInventoryListingId } from "./vintedBatches";

/** Wardrobe `per_page` for inventory daily — one Downloads blob per API page. */
export const VintedInventoryDailyPageSize = 40;

/**
 * Listing ids from a daily inventory Storage payload (raw wardrobe rows, or
 * already-transformed rows with "Platform Listing Id").
 */
export function listingIdsFromVintedInventoryDownloadPayload(
  data: unknown
): string[] {
  return listingIdsFromInventoryDownloadPayload(data, getInventoryListingId);
}

export function getExistingVintedInventoryListingIds(
  state: unknown
): Set<string> {
  return getExistingInventoryListingIds(state, "vinted");
}

/**
 * Pending `vintedInventory` Downloads with timestamp after the last inventory
 * sync cursor — progress from an aborted catch-up (cursor not advanced yet).
 */
export async function loadPendingVintedInventoryListingIds(args: {
  integrationId: string;
  lastSyncDate: Date;
  pendingInventoryEnabled?: boolean;
}): Promise<Set<string>> {
  return await loadPendingInventoryListingIds({
    ...args,
    downloadType: "vintedInventory",
    listingIdsFromPayload: listingIdsFromVintedInventoryDownloadPayload,
    logLabel: "Vinted",
    importPlatform: "vinted",
  });
}

export async function writeVintedInventoryDownloadBatch(args: {
  integration: VintedIntegration;
  items: unknown[];
  date: Date;
  timestamp: number;
  batchIndex: number;
  lock: SyncLock;
  pendingInventoryEnabled?: boolean;
}): Promise<void> {
  await writeInventoryDownloadBatch({
    integrationId: args.integration.id,
    items: args.items,
    date: args.date,
    timestamp: args.timestamp,
    batchIndex: args.batchIndex,
    lock: args.lock,
    storageFolder: "vintedInventory",
    downloadType: "vintedInventory",
    pendingInventoryEnabled: args.pendingInventoryEnabled,
  });
}
